import React from "react";
import { FaLinkedin, FaInstagram, FaGithub, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { contactPoints } from "../../data/contactPoints";

const steps = [
  {
    num: "1",
    title: "Send Your Message",
    desc: "Fill out the project scope builder—we'll review your objectives within 24 hours.",
  },
  {
    num: "2",
    title: "Scoping Discussion",
    desc: "We schedule a brief call to align on technical architecture, timeline, and MVP features.",
  },
  {
    num: "3",
    title: "Custom Roadmap",
    desc: "You receive a detail-oriented, fixed-price technical proposal and scope document.",
  },
];

const socialLinks = [
  { icon: FaLinkedin, url: contactPoints.linkedin, label: "LinkedIn" },
  { icon: FaInstagram, url: contactPoints.instagram, label: "Instagram" },
  { icon: FaGithub, url: contactPoints.github, label: "GitHub" },
];

const ContactDetails = () => {
  return (
    <div className="rounded-2xl p-7 lg:p-10 h-full flex flex-col justify-between"
         style={{ background: 'var(--bg-card)', border: '1px solid var(--border-color)' }}>
      <div>
        <h3 className="text-xl font-bold tracking-tight mb-8" style={{ color: 'var(--text-primary)' }}>
          What Happens Next?
        </h3>

        {/* ── Timeline Process ── */}
        <div className="relative space-y-8 pl-1">
          {/* Vertical line connector */}
          <div className="absolute left-[17px] top-2 bottom-2 w-[1.5px] border-l border-dashed"
               style={{ borderColor: 'var(--border-color)' }} />

          {steps.map((s, idx) => (
            <div key={idx} className="relative flex items-start gap-5">
              {/* Badge number */}
              <div className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-xs font-black relative z-10"
                   style={{
                     background: 'var(--bg-primary)',
                     border: '1.5px solid var(--border-color)',
                     color: 'var(--text-primary)'
                   }}>
                {s.num}
              </div>

              {/* Step info */}
              <div className="pt-0.5">
                <h4 className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>
                  {s.title}
                </h4>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12 pt-8 border-t space-y-6" style={{ borderColor: 'var(--border-color)' }}>
        {/* Direct Email */}
        <div className="flex items-center gap-3.5 group">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300"
               style={{ background: 'var(--accent-soft)', color: 'var(--accent)' }}>
            <FaEnvelope size={15} />
          </div>
          <div>
            <span className="text-[10px] font-black uppercase tracking-wider text-slate-400">Direct Email</span>
            <p className="text-sm font-bold" style={{ color: 'var(--text-primary)' }}>
              <a href={`mailto:${contactPoints.email}`} className="hover:text-[var(--accent)] transition-colors">
                {contactPoints.email}
              </a>
            </p>
          </div>
        </div>

        {/* Direct Phone */}
        <div className="flex items-center gap-3.5 group">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300"
               style={{ background: 'var(--accent-soft)', color: 'var(--accent)' }}>
            <FaPhoneAlt size={14} />
          </div>
          <div>
            <span className="text-[10px] font-black uppercase tracking-wider text-slate-400">Direct Phone</span>
            <p className="text-sm font-bold" style={{ color: 'var(--text-primary)' }}>
              <a href={`tel:${contactPoints.phone}`} className="hover:text-[var(--accent)] transition-colors">
                {contactPoints.phone}
              </a>
            </p>
          </div>
        </div>

        {/* Social media links */}
        <div className="flex items-center gap-3 pt-2">
          {socialLinks.map((sub, i) => (
            <a
              key={i}
              href={sub.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-lg border flex items-center justify-center text-slate-400 hover:text-white transition-all hover:bg-slate-900 duration-300"
              style={{ borderColor: 'var(--border-color)', background: 'var(--bg-primary)' }}
              title={sub.label}
            >
              <sub.icon size={14} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;